import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { PortalBuilderService } from '../shared/services/administratior-service/portal-builder.service';
import { Subscription } from 'rxjs';
import { CityServicesService } from '../shared/services/city-services/city-services.service';
import { StateServicesService } from '../shared/services/state-services/state-services.service';
import { ConfiguratorService } from '../shared/services/configurator-service/configurator.service';
import { ToastrService } from 'ngx-toastr';
import { LanguagesService } from '../shared/services/languages/languages.service';

@Component({
  selector: 'app-edit-portal-builder',
  templateUrl: './edit-portal-builder.component.html',
  styleUrls: ['./edit-portal-builder.component.css'],
})
export class EditPortalBuilderComponent implements OnInit, OnDestroy {
  shemeA = false;
  shemeB = false;
  portalBuilderForm!: FormGroup;
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '400px',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText',
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadUrl: 'v1/image',
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [['bold', 'italic'], ['fontSize']],
  };
  selectedColor = '#0058e9';
  selectedSecoundaryColor = '#922C88';
  cards = [
    {
      heading: 'Header Logo',
      logo: '../../assets/image/logo.png',
      button: 'Upload',
      type: 'Hlogo',
    },
    {
      heading: 'Footer  Logo',
      logo: '../../assets/image/logo.png',
      button: 'Upload',
      type: 'Flogo',
    },
    {
      heading: 'Favicon',
      logo: '../../assets/image/logo.png',
      button: 'Upload',
      type: 'Favlogo',
    },
  ];
  colors = [
    {
      colorCode: '#0058e9',
    },
    {
      colorCode: '#0CAF60',
    },
    {
      colorCode: '#584ED2',
    },
    {
      colorCode: '#6FD943',
    },
    {
      colorCode: '#145388',
    },
    {
      colorCode: '#922C88',
    },
    {
      colorCode: '#C0A145',
    },
    {
      colorCode: '#48494B',
    },
    {
      colorCode: '#0C7785',
    },
  ];

  bankSettingForm = [
    {
      heading: 'Partner Name',
      placeholder: 'Enter Partner Name',
      formControlName: 'bankName',
    },
    {
      heading: 'Address',
      placeholder: 'Enter Address',
      formControlName: 'bankAddress',
      errorMsg: 'Enter valid bank address'
    },
    {
      heading: 'Zip/Post Code',
      placeholder: 'Enter PostalCode',
      formControlName: 'postalCode',
      errorMsg: 'Enter valid postal code'
    },

    {
      heading: 'Telephone',
      placeholder: 'Enter Telephone',
      formControlName: 'bankTelephone',
      errorMsg: 'Enter valid number'
    },
    {
      heading: 'Bank Website',
      placeholder: 'Enter Bank Website',
      formControlName: 'bankWebsite',
      errorMsg: 'Enter valid website'
    },
    // {
    //   heading: 'Country',
    //   placeholder: 'Select Country',
    //   formControlName: 'country',
    //   errorMsg: 'Enter valid country'
    // },
  ];
  payOutTableData = [
    {
      range: '1-1000',
      chargeType: '',
      partner: 'Enter Value',
      rangeChargeType: 'chargeTypeOne',
      rangeChargePartner: 'chargePartnerOne',
    },
    {
      range: '1000-25000',
      chargeType: '',
      partner: 'Enter Value',
      rangeChargeType: 'chargeTypeTwo',
      rangeChargePartner: 'chargePartnerTwo',
    },
    {
      range: '25000-500000',
      chargeType: '',
      partner: 'Enter Value',
      rangeChargeType: 'chargeTypeThree',
      rangeChargePartner: 'chargePartnerThree',
    },
  ];
  currencyData: any = [];
  selectedFileHlogo: any;
  selectedFileFlogo: any;
  selectedFileFavlogo: any;
  folderName: any = 'test';
  headerLogo: any;
  footerLogo: any;
  favLogo: any;
  showSkip: boolean = false;
  selectedCurrency: any;
  cityData: any = [];
  urlPattern =
    '^((https?|ftp|smtp):\\/\\/)?(www.)?[a-z0-9]+([\\-.]{1}[a-z0-9]+)*\\.[a-z]{2,5}' +
    '((\\/[\\w\\-]+)*\\/)?([\\w\\-]+\\.[\\w]{2,4}(\\?[\\w\\-]+=[\\w\\-]+)?)?$';
  selectedCity: any;
  stateData: any = [];
  selectedState: any;
  schemeData: any = [];
  skip: any;
  themeLookText: any = '';
  routeSubscription!: Subscription;
  roleId: any;
  languageList: any = [];
  selectedLanguage: any;
  portalBuilderRes: any;
  currencySymbolData: any = [];

  onClick(ev: any) {
    if (ev.target.value === 'shemeA') {
      this.shemeA = true;
      this.shemeB = false;
    }
    if (ev.target.value === 'shemeB') {
      this.shemeB = true;
      this.shemeA = false;
    }
  }

  userId: any;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private schemeService: ConfiguratorService,
    private cityService: CityServicesService,
    private formBuilder: FormBuilder,
    private stateService: StateServicesService,
    private portalBuilderServices: PortalBuilderService,
    private languageService: LanguagesService,
    private toastrMsgService: ToastrService
  ) {}

  ngOnInit() {
    const role = JSON.parse(localStorage.getItem('user') || '{}');
    this.roleId = role.role.type;
    this.portalBuilderForm = this.formBuilder.group({
      title: [''],
      defaultLanguage: [''],
      currency: [''],
      currencySymbol: [''],
      news: [''],
      billNotice: [''],
      bankNotice: [''],
      bankName: [''],
      bankAddress: ['', Validators.required],
      city: ['', Validators.required],
      state: ['',Validators.required],
      postalCode: ['', [Validators.required,Validators.pattern('[0-9]{6}')]],
      country: ['',],
      bankTelephone: [
        '',
        [Validators.required,Validators.maxLength(10), Validators.pattern(/^[6-9]\d{9}$/)],
      ],
      bankWebsite: ['', [Validators.required,  Validators.pattern(this.urlPattern)]],
      bankTimeZone: ['', Validators.required],
      ipRestrict: [''],
      supportContactNumber: [
        '',
        [Validators.required,Validators.maxLength(10), Validators.pattern(/^[6-9]\d{9}$/)],
      ],
      supportContactEmail: ['', [Validators.required,Validators.email]],
      payInPartner: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      chargeType: ['flat', Validators.required],
      chargeTypeOne: ['flat', Validators.required],
      chargeTypeTwo: ['flat', Validators.required],
      chargeTypeThree: ['flat', Validators.required],
      chargePartnerOne: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      chargePartnerTwo: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      chargePartnerThree: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
    });

    this.getCurrency();
    // this.getCityData();
    this.getStateData();
    this.getLanguageList();
    this.getSchemeData();
    this.route.queryParams.subscribe((v) => {
      if (v['edit'] == '0') {
        this.portalBuilderForm.disable();
      }
      this.routeSubscription = this.route.params.subscribe((param: any) => {
        this.userId = param.id;
        if (param?.showSkipBtn) {
          this.showSkip = Boolean(JSON.parse(param?.showSkipBtn));
        }
        if (this.userId) {
          this.getPortalBuilderDetails(this.userId);
        }
      });
    });
  }

  onCurrencySelect(ev: any) {
    this.currencySymbolData = this.currencyData;
    this.selectedCurrency = this.currencyData.find(
      (item: any) => item._id == ev.target.value
    );
    this.portalBuilderForm
      .get('currencySymbol')
      ?.patchValue(this.selectedCurrency.symbol);
    this.portalBuilderForm.get('currencySymbol')?.disable();
  }

  keyPressNumbers(event: any) {
    var charCode = event.which ? event.which : event.keyCode;
    // Only Numbers 0-9
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
  onCountrySelect(ev: any){
    this.portalBuilderForm.value.country=ev.target.value;
  }
  onCitySelect(ev: any) {
    this.selectedCity = this.cityData.find(
      (item: any) => item._id == ev.target.value
    );
  }

  onStateSelect(ev: any) {
    let pagination = {
      currentPage: 1,
      limit: 10000,
    };
    this.selectedState = this.stateData.find(
      (item: any) => item._id == ev.target.value
    );
    this.cityService
      .getCityWithPagination(pagination, this.selectedState._id)
      .subscribe((res: any) => {
        this.cityData = res.data.data;
      });
  }

  onLanguageSelect(ev: any) {
    this.selectedLanguage = this.languageList.find(
      (item: any) => item._id == ev.target.value
    );
  }

  getSchemeData() {
    this.schemeService.getAllSchemes().subscribe({
      next: (response: any) => {
        this.schemeData = response.data;
      },
      error: (error) => {
        console.error('Error  Creating state:', error);
      },
      complete: () => {
        console.log('Create request completed');
      },
    });
  }

  getLanguageList() {
    let pagination = {
      currentPage: 1,
      limit: 10000,
    };
    this.languageService.getLanguages(pagination).subscribe({
      next: (response: any) => {
        this.languageList = response.data.data;
        let english = this.languageList.find(
          (item: any) => item.title == 'English'
        );
        this.portalBuilderForm.get('defaultLanguage')?.patchValue(english._id);
        this.selectedLanguage = english;
      },
      error: (error) => {
        console.error('Error  Creating state:', error);
      },
      complete: () => {
        console.log('Create request completed');
      },
    });
  }

  getCityData() {
    let pagination = {
      currentPage: 1,
      limit: 10000,
    };
    this.cityService.getCityWithPagination(pagination).subscribe({
      next: (response) => {
        this.cityData = response.data.data;
      },
      error: (error) => {
        console.error('Error  Creating state:', error);
      },
      complete: () => {
        console.log('Create request completed');
      },
    });
  }

  getStateData() {
    let pagination = {
      currentPage: 1,
      limit: 10000,
    };
    this.stateService.getStateWithPagination(pagination).subscribe({
      next: (response) => {
        this.stateData = response.data.data;
      },
      error: (error) => {
        console.error('Error  Creating state:', error);
      },
      complete: () => {
        console.log('Create request completed');
      },
    });
  }

  createPortalBuilder() {
    let formattedData = {
      userId: this.userId,
      bankNotice: this.portalBuilderForm.value.bankNotice
        ? this.portalBuilderForm.value.bankNotice
        : this.portalBuilderRes?.bankNotice,
      businessConfig: {
        headerLogo: this.cards[0]?.logo
          ? this.cards[0]?.logo
          : this.portalBuilderRes?.businessConfig?.headerLogo,
        footerLogo: this.cards[1]?.logo
          ? this.cards[1]?.logo
          : this.portalBuilderRes?.businessConfig?.footerLogo,
        faviconLogo: this.cards[2]?.logo
          ? this.cards[2]?.logo
          : this.portalBuilderRes?.businessConfig?.faviconLogo,
        title: this.portalBuilderRes?.businessConfig?.title,
        defaultLanguage:
          this.selectedLanguage ??
          this.portalBuilderRes?.businessConfig?.defaultLanguage,
        primaryColor: this.selectedColor
          ? this.selectedColor
          : this.portalBuilderRes?.businessConfig?.selectedColor,
        secondaryColor: this.selectedSecoundaryColor
          ? this.selectedSecoundaryColor
          : this.portalBuilderRes?.businessConfig?.selectedSecoundaryColor,
      },
      systemConfig: {
        currency: {
          currencyId: this.selectedCurrency?._id
            ? this.selectedCurrency?._id
            : this.portalBuilderRes?.systemConfig?.currency?.currencyId,
          title: this.selectedCurrency?.title
            ? this.selectedCurrency?.title
            : this.portalBuilderRes?.systemConfig?.currency?.title,
          symbol: this.selectedCurrency?.symbol
            ? this.selectedCurrency?.symbol
            : this.portalBuilderRes?.systemConfig?.currency?.symbol,
        },
      },
      newsConfig: {
        news: this.portalBuilderForm.value.news
          ? this.portalBuilderForm.value.news
          : this.portalBuilderRes?.newsConfig?.news,
        billNotice: this.portalBuilderForm.value.billNotice
          ? this.portalBuilderForm.value.billNotice
          : this.portalBuilderRes?.newsConfig?.billNotice,
      },
      bankConfig: {
        bankName: this.portalBuilderRes?.businessConfig?.title,
        bankAddress: this.portalBuilderForm.value.bankAddress
          ? this.portalBuilderForm.value.bankAddress
          : this.portalBuilderRes?.bankConfig?.bankAddress,
        postalCode: this.portalBuilderForm.value.postalCode
          ? this.portalBuilderForm.value.postalCode
          : this.portalBuilderRes?.bankConfig?.postalCode,
        country: this.portalBuilderForm.value.country
          ? this.portalBuilderForm.value.country
          : this.portalBuilderRes?.bankConfig?.country,
        bankTelephone: this.portalBuilderForm.value.bankTelephone
          ? this.portalBuilderForm.value.bankTelephone
          : this.portalBuilderRes?.bankConfig?.bankTelephone,
        bankWebsite: this.portalBuilderForm.value.bankWebsite
          ? this.portalBuilderForm.value.bankWebsite
          : this.portalBuilderRes?.bankConfig?.bankWebsite,
        bankTimeZone: this.portalBuilderForm.value.bankTimeZone
          ? this.portalBuilderForm.value.bankTimeZone
          : this.portalBuilderRes?.bankConfig?.bankTimeZone,
        ipRestrict: this.portalBuilderForm.value.ipRestrict
          ? this.portalBuilderForm.value.ipRestrict
          : this.portalBuilderRes?.bankConfig?.ipRestrict,
        supportContactNumber: this.portalBuilderForm.value.supportContactNumber
          ? this.portalBuilderForm.value.supportContactNumber
          : this.portalBuilderRes?.bankConfig?.supportContactNumber,
        supportContactEmail: this.portalBuilderForm.value.supportContactEmail
          ? this.portalBuilderForm.value.supportContactEmail
          : this.portalBuilderRes?.bankConfig?.supportContactEmail,
        city: {
          title: this.selectedCity?.title
            ? this.selectedCity?.title
            : this.portalBuilderRes?.bankConfig?.city?.title,
          cityId: this.selectedCity?._id
            ? this.selectedCity?._id
            : this.portalBuilderRes?.bankConfig?.city?.cityId,
        },
        state: {
          title: this.selectedState?.title
            ? this.selectedState?.title
            : this.portalBuilderRes?.bankConfig?.state?.title,
          stateId: this.selectedState?._id
            ? this.selectedState?._id
            : this.portalBuilderRes?.bankConfig?.state?.stateId,
        },
      },
      schemeConfig: {
        payOut: [
          {
            chargeType: this.portalBuilderForm.value.chargeTypeOne
              ? this.portalBuilderForm.value.chargeTypeOne
              : this.portalBuilderRes?.schemeConfig?.payOut[0]?.chargeType,
            fintegrator: this.portalBuilderForm.value.chargePartnerOne
              ? this.portalBuilderForm.value.chargePartnerOne
              : this.portalBuilderRes?.schemeConfig?.payOut[0]?.fintegrator,
            name: 'slab1',
            range: '1-1000',
            minAmount: 1,
            maxAmount: 1000,
          },
          {
            chargeType: this.portalBuilderForm.value.chargeTypeTwo
              ? this.portalBuilderForm.value.chargeTypeTwo
              : this.portalBuilderRes?.schemeConfig?.payOut[1]?.chargeType,
            fintegrator: this.portalBuilderForm.value.chargePartnerTwo
              ? this.portalBuilderForm.value.chargePartnerTwo
              : this.portalBuilderRes?.schemeConfig?.payOut[1]?.fintegrator,
            name: 'slab2',
            range: '1000-25000',
            minAmount: 1000,
            maxAmount: 25000,
          },
          {
            chargeType: this.portalBuilderForm.value.chargeTypeThree
              ? this.portalBuilderForm.value.chargeTypeThree
              : this.portalBuilderRes?.schemeConfig?.payOut[2]?.chargeType,
            fintegrator: this.portalBuilderForm.value.chargePartnerThree
              ? this.portalBuilderForm.value.chargePartnerThree
              : this.portalBuilderRes?.schemeConfig?.payOut[2]?.fintegrator,
            name: 'slab3',
            range: '25000-500000',
            minAmount: 25000,
            maxAmount: 500000,
          },
        ],
        payIn: {
          fintegrator: this.portalBuilderForm.value.payInPartner
            ? this.portalBuilderForm.value.payInPartner
            : this.portalBuilderRes?.schemeConfig?.payIn?.fintegrator,
          chargeType: this.portalBuilderForm.value.chargeType
            ? this.portalBuilderForm.value.chargeType
            : this.portalBuilderRes?.schemeConfig?.payIn?.chargeType,
        },
      },
    };
    if (this.portalBuilderForm.valid) {
      this.portalBuilderServices.createAdminPortal(formattedData).subscribe({
        next: (response) => {
          this.toastrMsgService.success('Partner updated Successfully');
          this.getPortalBuilderDetails(response.data.userId);
          this.router.navigate(['/home/customer/partnerProfile']);

        },
        error: (error) => {
          this.toastrMsgService.error(error.error.errorMessage);
        },
        complete: () => {
          console.log('Create request completed');
        },
      });
    } else {
      this.portalBuilderForm.markAllAsTouched();
      this.toastrMsgService.warning('Please Enter valid values');
    }
  }

  onPrimeryColorChange(color: string) {
    this.selectedColor = color;
    document.documentElement.style.setProperty('--primary', color);
    this.themeLookText =
      'Customize the theme below. See your choices transform the portal instantly!';
  }

  onSecondaryColorChange(color: string) {
    this.selectedSecoundaryColor = color;
    document.documentElement.style.setProperty('--secondary', color);
    this.themeLookText =
      'Customize the theme below. See your choices transform the portal instantly!';
  }

  getCurrency() {
    this.portalBuilderServices.GetCurrency().subscribe({
      next: (response) => {
        this.currencyData = response.data.data;
      },
      error: (error) => {
        console.error('Error  currency state:', error);
      },
      complete: () => {
        console.log('upload currency completed');
      },
    });
  }

  getPortalBuilderDetails(id: any) {
    this.portalBuilderServices.getAdminPortalBuilder(id).subscribe({
      next: (response) => {
        this.portalBuilderRes = response.data;
        this.patchPortalForm(response.data);
      },
      error: (error) => {
        console.error('Error  currency state:', error);
      },
      complete: () => {
        console.log('upload currency completed');
      },
    });
  }

  patchPortalForm(data: any) {
    if(data?.bankConfig?.city?.cityId) {
    let pagination = {
      limit: 10000,
currentPage: 1
    }
    this.cityService
    .getCityWithPagination(pagination, data?.bankConfig?.state?.stateId)
    .subscribe((res: any) => {
      this.cityData = res.data.data;
      setTimeout(() => {
        this.portalBuilderForm.patchValue({
          city: data?.bankConfig?.city?.cityId
          ? data?.bankConfig?.city?.cityId
          : ''
        })
      },1000)
    });
  }
    if(data?.systemConfig?.currency?.symbol) {
      this.currencySymbolData = this.currencyData;
    }
    this.portalBuilderForm.patchValue({
      title: data?.businessConfig?.title,
      defaultLanguage:
        data?.businessConfig?.defaultLanguage ??
        data?.businessConfig?.defaultLanguage?._id,
      currency: data?.systemConfig?.currency?.currencyId
        ? data?.systemConfig?.currency?.currencyId
        : '',
      currencySymbol: data?.systemConfig?.currency?.symbol
        ? data?.systemConfig?.currency?.symbol
        : '',
      news: data?.newsConfig?.news,
      billNotice: data?.newsConfig?.billNotice,
      bankNotice: data?.bankNotice,
      bankName: data?.businessConfig?.title,
      bankAddress: data?.bankConfig?.bankAddress,
      state: data?.bankConfig?.state?.stateId
        ? data?.bankConfig?.state?.stateId
        : '',
      postalCode: data?.bankConfig?.postalCode,
      country: data?.bankConfig?.country,
      bankTelephone: data?.bankConfig?.bankTelephone,
      bankWebsite: data?.bankConfig?.bankWebsite,
      bankTimeZone: data?.bankConfig?.bankTimeZone
        ? data?.bankConfig?.bankTimeZone
        : '',
      ipRestrict: data?.bankConfig?.ipRestrict,
      supportContactNumber: data?.bankConfig?.supportContactNumber,
      supportContactEmail: data?.bankConfig?.supportContactEmail,
      payInPartner: data?.schemeConfig?.payIn?.fintegrator,
      chargeType: data?.schemeConfig?.payIn?.chargeType
        ? data?.schemeConfig?.payIn?.chargeType
        : 'flat',
      chargeTypeOne: data?.schemeConfig?.payOut[0]?.chargeType ?? 'flat',
      chargeTypeTwo: data?.schemeConfig?.payOut[1]?.chargeType ?? 'flat',
      chargeTypeThree: data?.schemeConfig?.payOut[2]?.chargeType ?? 'flat',
      chargePartnerOne: data?.schemeConfig?.payOut[0]?.fintegrator,
      chargePartnerTwo: data?.schemeConfig?.payOut[1]?.fintegrator,
      chargePartnerThree: data?.schemeConfig?.payOut[2]?.fintegrator,
    });

    this.portalBuilderForm.get('title')?.disable();
    this.portalBuilderForm.get('bankName')?.disable();

    this.cards[0].logo = data?.businessConfig?.headerLogo;
    this.cards[1].logo = data?.businessConfig?.footerLogo;
    this.cards[2].logo = data?.businessConfig?.faviconLogo;
    this.selectedColor = data?.businessConfig?.primaryColor ? data?.businessConfig?.primaryColor : '#0058e9';
    this.selectedSecoundaryColor =
      data?.businessConfig?.secondaryColor ? data?.businessConfig?.secondaryColor : '#922C88';
  }

  onFileSelected(event: any, type: any) {
    if (type == 'Hlogo') {
      this.selectedFileHlogo = event.target.files[0];
      this.cards[0].logo = URL.createObjectURL(this.selectedFileHlogo);
      this.uploadImgAPI(
        this.selectedFileHlogo?.type,
        this.folderName,
        this.selectedFileHlogo,
        'Hlogo'
      );
    }
    if (type == 'Flogo') {
      this.selectedFileFlogo = event.target.files[0];
      this.cards[1].logo = URL.createObjectURL(this.selectedFileFlogo);
      this.uploadImgAPI(
        this.selectedFileFlogo?.type,
        this.folderName,
        this.selectedFileFlogo,
        'Flogo'
      );
    }
    if (type == 'Favlogo') {
      this.selectedFileFavlogo = event.target.files[0];
      this.cards[2].logo = URL.createObjectURL(this.selectedFileFavlogo);
      this.uploadImgAPI(
        this.selectedFileFlogo?.type,
        this.folderName,
        this.selectedFileFavlogo,
        'Favlogo'
      );
    }
  }

  uploadImgAPI(type: any, folder_name: any, image: any, logoType: string) {
    this.portalBuilderServices.fileUpload(type, folder_name, image).subscribe({
      next: (response: any) => {
        if (logoType == 'Hlogo') {
          this.cards[0].logo = response.data;
        }
        if (logoType == 'Flogo') {
          this.cards[1].logo = response.data;
        }
        if (logoType == 'Favlogo') {
          this.cards[2].logo = response.data;
        }
      },
      error: (error) => {
        console.error('Error  upload state:', error);
      },
      complete: () => {
        console.log('upload request completed');
      },
    });
  }

  ngOnDestroy() {
    this.routeSubscription?.unsubscribe();
    const theamConfig = JSON.parse(
      localStorage.getItem('theamConfig') || '{}'
    );
    document.documentElement.style.setProperty('--primary', '#0058e9');
    document.documentElement.style.setProperty('--secondary', '#922C88');
  }
}
